<template>
    <keep-alive>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')">
                        <span class="sr_only">popup close</span>
                    </a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>Upper Code Search</i>
                        </dt>
                        <dd>
                            <div class="srchModal_wrap">
                                <dl class="dl_search_pop">
                                    <dd data-input-type="select" class="sech">
                                        <dt class="tit">{{$t('FIELD.CODEMNG.CODE.TYPE')}}</dt> 
                                        <dt data-input-type="select" class="sel">
                                           <select class="slt_white w100" v-model="categoryType">
                                                <option value="" selected >{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option value="D">Dynamic</option>
                                                <option value="S">Static</option>
                                            </select>
                                        </dt>
                                    </dd> 
                                    <dd data-input-type="select" class="sech">
                                        <dt class="tit">{{$t('FIELD.CODEMNG.CASH.STATUS')}}</dt> 
                                        <dt data-input-type="select" class="sel">
                                           <select class="slt_white w100" v-model="cacheStatus">
                                                <option value="" selected >{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option value="N">{{$t('FIELD.GLOBAL.NO')}}</option>
                                                <option value="Y">{{$t('FIELD.GLOBAL.YES')}}</option>
                                            </select>
                                        </dt>
                                    </dd> 
                                    <dd data-input-type="input" class="sech">
                                        <dt class="tit">{{$t('FIELD.CODEMNG.CODE.NAME')}}</dt> 
                                        <dt data-input-type="select" class="sel">
                                           <span class="clearable">
                                                <input type="text" class="text_input w100" ref="categoryName" v-model="categoryName" @keyup.enter.stop="onSearch()"/>
                                                <i class="clearable_clear">X</i>
                                            </span>
                                        </dt>
                                    </dd> 
                                    <dd data-input-type="select" class="sech">
                                        <dt class="tit">{{$t('FIELD.CODEMNG.CODE.ID')}}</dt> 
                                        <dt data-input-type="input" class="sel">
                                             <span class="clearable">
                                                <input type="text" class="text_input w100" v-model="categoryId" @keyup.enter.stop="onSearch()" />
                                                <i class="clearable_clear">X</i>
                                            </span>
                                        </dt>
                                    </dd> 
                                    <dd class="btn">
                                        <a
                                                href="JavaScript:"
                                                class="btn_srch"
                                                @click="onSearch()"
                                            >{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                                    </dd>
                                </dl>
                            </div>

                            <div class="grid_wrap mt-10">
                                <toast-grid
                                    :gridId="gridId"
                                    :columns="columns"
                                    :data="gridData"
                                    :options="options"
                                    :ref="gridId"
                                    :key="gridKey"
                                    :pageOptions="pageOptions"
                                    :isTotalCount="true"
                                    :click="contentClick"
                                />
                            </div>
                            <div class="btn_modal_wrap topLine">
                                <div class="btn_right">
                                    <a
                                        href="JavaScript:"
                                        class="btn_blue"
                                        @click="onApply()"
                                    >{{$t('BUTTON.GLOBAL.APPLY')}}</a>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import ToastGrid from '~c/ToastGrid';

// Toast Grid Custom Renderer
class RadioButtonType {
    constructor(props) {
        const el = document.createElement('input');
        el.setAttribute('type', 'radio');
        el.setAttribute('name', 'radio');
        el.classList.add('radio-icon');
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

class CategoryType {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        if (resVal == 'S') resVal = 'Static';
        else if (resVal == 'D') resVal = 'Dynamic';
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'searchModelPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        searchModel: {type: String, default: ''},
        pCategoryId: {type: String, default: ''},
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            gridId: 'searchPopupGrid',
            categoryType: '',
            categoryId: '',
            categoryName: '',
            cacheStatus: '',
            searchName: this.searchModel,
            gridKey: 0,
            columns: [
                {
                    header: '',
                    name: '',
                    align: 'center',
                    width: 40,
                    resizable: true,
                    sortable: false,
                    renderer: { type: RadioButtonType },
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.TYPE'),
                    name: 'CODETYPECODE',
                    width: 100,
                    align: 'center',
                    sortable: false,
                    renderer: { type: CategoryType },
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.ID'),
                    name: 'CODECATEGORYID',
                    width: 170,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CODE.NAME'),
                    name: 'CODECATEGORYNAME',
                    width: 210,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USE.STATUS'),
                    name: 'STATUSCODE',
                    align: 'center',
                    width: 87,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.CODEMNG.CASH.STATUS'),
                    name: 'CACHEYN',
                    align: 'center',
                    width: 90,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 320,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 8,
            },
        };
    },
    methods: {
        prepSearchParams(exclude = []) {
            let params = {
                page: 1,
                currentPage: 1,
                perPage: '99999',
                codeTypeCode: this.categoryType,
                pCodeId: this.pCategoryId,
                codeId: this.categoryId,
                codeName: this.categoryName,
                cacheYn: this.cacheStatus,
                //                ORDER_COLUMN: this.ORDER_COLUMN,
                //                ORDER_ASC: this.ORDER_ASC
            };
//            console.log('search.params ==> ', params);
            return params;
        },
        async onSearch() {
            const formData = this.prepSearchParams();

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/code/codeAdminList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onApply() {
            this.rtnFunc(this.categoryId);
            this.$emit('close');
        },
        contentClick(e, rowData, grid) {
            let curRowKey = e.rowKey;
            if (curRowKey > this.pageOptions.perPage) {
                curRowKey = e.rowKey % this.pageOptions.perPage;
            }

            if ($('.radio-icon')[curRowKey].checked) {
                this.categoryId = rowData[e.rowKey]['CODECATEGORYID'];
                this.categoryName = rowData[e.rowKey]['CODECATEGORYNAME'];
            }
            // console.log('contentClick',e.rowKey,curRowKey,$('.radio-icon')[curRowKey].checked,rowData[e.rowKey]['CDMODEL'],rowData[e.rowKey]['NMMODEL']);
        },
    },
    mounted() {
        this.onSearch();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/code/UpperCodePopup.vue